import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { Scan } from '@softline/application';

@Injectable()
export class StorageLocationSearchRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  // TODO: Which Endpoint???
  async findStockyard(scan: Scan): Promise<object> {
    const response = await this.#dataAccess.get<ResponseResult<object>>({
      path: '',
    });

    return response.result;
  }
}
